import { render } from "./packages.vue?vue&type=template&id=074b7cca&scoped=true"
import script from "./packages.vue?vue&type=script&lang=js"
export * from "./packages.vue?vue&type=script&lang=js"

import "./packages.vue?vue&type=style&index=0&id=074b7cca&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-074b7cca"]])

export default __exports__